import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';

function Form() {

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const path = '/bankaccounts/';
    const paths = {
        endpointSave: config.endpoints.backend + 'bankaccounts/save',
        endpointGetById: config.endpoints.backend + 'bankaccounts/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllBankAgencies: config.endpoints.backend + 'bankagencies/getall',
        endpointGetAllBankAccountTypes: config.endpoints.backend + 'bankaccounttypes/getall',
        endpointGetAllResourceSources: config.endpoints.backend + 'resourcesources/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Conta Bancária",
        labelTitleEdit: "Editar Conta Bancária",
        labelTitleView: 'Visualizar Conta Bancária'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                {
                    name: 'pdc_bank_agency_id',
                    type: 'select',
                    label: 'Agência',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAgencies,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                pdc_project_id: values.pdc_project_id || 'not-list'
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'pdc_bank_account_type_id',
                    type: 'select',
                    label: 'Tipo de Conta',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAccountTypes,
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'pdc_resource_source_id',
                    type: 'select',
                    label: 'Origem de Recurso',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllResourceSources,
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'accountid',
                    type: 'text',
                    label: 'Conta com Dígito',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'people',
                    type: 'text',
                    label: 'Titular da Conta',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
